import { IconAddUser } from '@/components/icon/IconAddUser'

/* eslint-disable tailwindcss/no-custom-classname */
interface Props {
  link: string
  buttonText: string
  borderText?: string
  buttonSubText?: string
}
export const ReadMore: React.FC<Props> = ({
  link,
  buttonText,
  borderText = '',
  buttonSubText = '',
}) => {
  return (
    <>
      <img
        src={`${process.env.IMG_SERVER}/common/readmore.png`}
        alt="もっと見る"
        className="mt-[-160px] w-full h-[160px] align-middle border-none"
      />
      <div className="mb-5">
        <div className="pt-[10px] pb-[10px] text-2xl leading-snug">
          <div className="flex before:flex-grow after:flex-grow items-center before:mr-[1rem] after:ml-[1rem] before:h-[1px] after:h-[1px] text-base font-bold text-center text-[#222] before:bg-[#c4c4c4] after:bg-[#c4c4c4] before:border-b after:border-b before:border-[#fff] after:border-[#fff] before:border-dotted after:border-dotted before:content-[''] after:content-['']">
            {borderText}
          </div>
          <div className="mx-auto mt-[30px] mb-0 w-full text-center bg-white sm:bg-[#f9f9f9]">
            <div className="flex sm:inline-block justify-center sm:justify-start items-center">
              <img
                src={`${process.env.IMG_SERVER}/prd-ab-test/cta_rei_image_pc.png`}
                alt={buttonText}
                className="float-left w-[24vw] sm:w-[240px] h-auto sm:h-[244px] align-middle rounded-tr-[3px] border-none"
              />
              <div className="float-left relative top-0 sm:top-[60px] px-2 sm:px-4 pt-0 pb-5 text-center">
                <p className="relative before:absolute after:absolute before:top-[13px] after:top-[13px] after:right-0 sm:after:right-[3em] before:left-0 sm:before:left-[3em] py-0 px-[22px] mx-0 mt-3 mb-[10px] before:w-5 after:w-5 before:h-[1px] after:h-[1px] text-[13px] sm:text-[15px] font-normal tracking-[0.38px] leading-[180%] text-[#fd8637] before:bg-[#fd8637] after:bg-[#fd8637] before:rotate-45 after:rotate-[-45deg] before:content-[''] after:content-['']">
                  {buttonSubText}
                </p>
                <a
                  href={link}
                  className="text-[#2dacdb] hover:text-[#23527c] no-underline hover:underline border-b border-transparent border-solid hover:outline-none"
                >
                  <div className="inline-block relative pt-[9px] pr-3 pb-2 pl-[10px] mb-0 w-full sm:w-[340px] h-[45px] text-[13px] font-normal leading-normal text-center text-white align-middle whitespace-nowrap bg-[#fd8637] rounded-[4px] border-none hover:opacity-70 cursor-pointer shadow-[0_2px_0_#c96b2b]">
                    <div className="flex justify-center items-center">
                      {!link.includes('upgrade') && (
                        <IconAddUser className="w-[25px] h-[25px]" />
                      )}
                      <div className="pl-[5px]">
                        <div className="text-base">{buttonText}</div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
